import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
const { projectCode } = PROJECT_CODE;

export async function getProjectById(projectId) {
	var projectName;
	firebaseRef
		.ref('/kavtek_companies/' + projectId + '/companyName/')
		.on('value', (snapshot) => {
			projectName = snapshot.val();
		});

	return projectName;
}
